// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Popover_wrapper__fiL5a","mask":"Popover_mask__A-cKP"};